import React from "react";
import Index from "./view/index/Index";
import Game from "./view/game/Index";
// import Task from "./view/task/Index";
import Welfare from "./view/welfare/Index";
import Trade from "./view/trade/Index";
import User from "./view/user/Index";

const Service = React.lazy(() => import("./view/service/Service"));
const TodayStartGame = React.lazy(() => import("./view/game/TodayStart"));
const ReserveGame = React.lazy(() => import("./view/game/Reserve"));
const GameGame = React.lazy(() => import("./view/game/Game"));
const GameVoucher = React.lazy(() => import("./view/game/Voucher"));
const GameGift = React.lazy(() => import("./view/game/Gift"));
const GameGiftDetail = React.lazy(() => import("./view/game/GiftDetail"));
const GameArticleGroup = React.lazy(() => import("./view/game/article/Groups"));
const GameArticle = React.lazy(() => import("./view/game/article/Articles"));
const Article = React.lazy(() => import("./view/article/Index"));
const GameProject = React.lazy(() => import("./view/game/Project"));
const IndexProject = React.lazy(() => import("./view/game/IndexProject"));
const Gifts = React.lazy(() => import("./view/gift/Gifts"));
const GiftSearch = React.lazy(() => import("./view/gift/Search"));
const Voucher = React.lazy(() => import("./view/voucher/Index"));
const VoucherLateplay = React.lazy(() => import("./view/voucher/Lateplay"));
const Server = React.lazy(() => import("./view/server/Index"));
const Credit = React.lazy(() => import("./view/credit/Index"));
const CreditGift = React.lazy(() => import("./view/credit/Gift"));
const Search = React.lazy(() => import("./view/search/Index"));
const Faq = React.lazy(() => import("./view/Faq"));
const TradeDetail = React.lazy(() => import("./view/trade/Detail"));
const TradeNotice = React.lazy(() => import("./view/trade/Notice"));
const ArticleDetail = React.lazy(() => import("./view/article/Detail"));
const CommentDetail = React.lazy(() => import("./view/comment/Detail"));
const CommentSubmit = React.lazy(() => import("./view/comment/Submit"));
const QAQuestion = React.lazy(() => import("./view/qa/Question"));
const QAAnswer = React.lazy(() => import("./view/qa/Answer"));
const Img = React.lazy(() => import("./view/general/Img"));
const Iframe = React.lazy(() => import("./view/general/Iframe"));
const GameSelect = React.lazy(() => import("./view/game/Select"));
const Feedback = React.lazy(() => import("./view/feedback/Index"));
const Forget = React.lazy(() => import("./view/account/Forget"));
const Register = React.lazy(() => import("./view/account/Register"));
const Login = React.lazy(() => import("./view/account/Login"));
const PhoneLogin = React.lazy(() => import("./view/account/PhoneLogin"));
const Phone = React.lazy(() => import("./view/account/Phone"));
const Video = React.lazy(() => import("./view/general/Video"));
const TaskSign = React.lazy(() => import("./view/task/Sign"));
const TaskNovice = React.lazy(() => import("./view/task/Novice"));
const TaskDay = React.lazy(() => import("./view/task/Day"));
const Messages = React.lazy(() => import("./view/message/Messages"));
const Message = React.lazy(() => import("./view/message/Message"));
const Rebate = React.lazy(() => import("./view/rebate/Index"));
const RebateGuide = React.lazy(() => import("./view/rebate/Guide"));
const RebateSubmit = React.lazy(() => import("./view/rebate/Submit"));
const RebateSuccess = React.lazy(() => import("./view/rebate/Success"));
const RebateDetail = React.lazy(() => import("./view/rebate/Detail"));
const UserProfile = React.lazy(() => import("./view/user/Profile"));
const UserSetting = React.lazy(() => import("./view/user/Setting"));
const UserNickname = React.lazy(() => import("./view/user/Nickname"));
const UserQQ = React.lazy(() => import("./view/user/QQ"));
const UserPhone = React.lazy(() => import("./view/user/Phone"));
const UserPhoneRemove = React.lazy(() => import("./view/user/PhoneRemove"));
const UserPhoneVerify = React.lazy(() => import("./view/user/PhoneVerify"));
const UserPhoneReplace = React.lazy(() => import("./view/user/PhoneReplace"));
const UserRealName = React.lazy(() => import("./view/user/Realname"));
const UserPassword = React.lazy(() => import("./view/user/Password"));
const UserPasswordPhone = React.lazy(() => import("./view/user/PasswordPhone"));
const PasswordForce = React.lazy(() => import("./view/user/PasswordForce"));
const UserCredit = React.lazy(() => import("./view/user/Credit"));
const UserVoucher = React.lazy(() => import("./view/user/Voucher"));
const UserGame = React.lazy(() => import("./view/user/game/Index"));
const UserReserveGame = React.lazy(
  () => import("./view/user/game/ReserveGame"),
);
const UserLikeGame = React.lazy(() => import("./view/user/game/LikeGame"));
const UserGift = React.lazy(() => import("./view/user/Gift"));
const Invite = React.lazy(() => import("./view/invite/Index"));
const Recovery = React.lazy(() => import("./view/recovery/Index"));
const RecoveryDetail = React.lazy(() => import("./view/recovery/Detail"));
const RecoveryRecord = React.lazy(() => import("./view/recovery/Record"));
const UserBill = React.lazy(() => import("./view/user/Bill"));
const Ptb = React.lazy(() => import("./view/ptb/Index"));
const PtbRecord = React.lazy(() => import("./view/ptb/Record"));
const VipWatch = React.lazy(() => import("./view/game/detail/VipWatch"));
const HangUp = React.lazy(() => import("./view/game/hangUp/Index"));
const DetailTrade = React.lazy(() => import("./view/game/detail/Trade"));
const ServiceDetail = React.lazy(() => import("./view/service/Detail"));
const Desktop = React.lazy(() => import("./view/game/cloud/Desktop1"));
const Question = React.lazy(() => import("./view/game/detail/QuestionDetail"));
const QuestionList = React.lazy(
  () => import("./view/game/detail/QuestionList"),
);
const TradeSearch = React.lazy(() => import("./view/trade/Search"));
const GameCloud = React.lazy(() => import("./view/game/cloud/Index"));
const FeedbackHistory = React.lazy(
  () => import("./view/feedback/history/List"),
);
const FeedbackHistoryDetail = React.lazy(
  () => import("./view/feedback/history/Detail"),
);

export const screenRouter = [
  {
    id: "index",
    path: "/",
    component: Index,
    title: "首页",
  },
  {
    id: "game",
    path: "/screen-game",
    component: Game,
    title: "分类",
  },
  /*{
    id: 'task',
    path: '/screen-task',
    component: Task,
    title: '积分',
    user: true,
  },*/
  {
    id: "welfare",
    path: "/screen-welfare",
    component: Welfare,
    title: "福利中心",
    // user: true,
  },
  {
    id: "service",
    path: "/screen-trade",
    component: Trade,
    title: "交易",
  },
  /*{
    id: 'service',
    path: '/screen-service',
    component: Service,
    title: '客服',
  },*/
  {
    id: "user",
    path: "/screen-user",
    component: User,
    title: "我的",
  },
];

export const navigationRouter = [
  {
    path: "/question",
    component: Question,
    title: "常见问题",
  },
  {
    path: "/desktop",
    component: Desktop,
    title: "云桌面",
  },
  {
    path: "/game/hangup",
    component: HangUp,
    title: "云挂机",
  },
  {
    path: "/game/vip",
    component: VipWatch,
    title: "vip表",
  },

  {
    path: "/game/today-start",
    component: TodayStartGame,
    title: "新游预约",
  },
  {
    path: "/game/reserve",
    component: ReserveGame,
    title: "新游预约",
  },
  {
    path: "/game",
    component: GameGame,
    title: "游戏详情",
    topHidden: true,
    invasion: true,
    statusBarBackground: false,
  },
  {
    path: "/game/questionList",
    component: QuestionList,
    title: "IOS安装常见问题",
  },
  {
    path: "/game/voucher",
    component: GameVoucher,
    title: "代金券",
  },

  {
    path: "/game/trade",
    component: DetailTrade,
    title: "精选交易",
  },
  {
    path: "/game/gift",
    component: GameGift,
    title: "礼包",
  },
  {
    path: "/game/giftDetail",
    component: GameGiftDetail,
    title: "礼包",
  },
  {
    path: "/game/articleGroup",
    component: GameArticleGroup,
    title: "活动攻略",
  },
  {
    path: "/game/article",
    component: GameArticle,
    title: "活动攻略",
  },
  {
    path: "/article",
    component: Article,
    title: "活动中心",
  },
  {
    path: "/game/project",
    component: GameProject,
  },
  {
    path: "/game/indexProject",
    component: IndexProject,
    title: "专题详情",
    // invasion: true,
    // statusBarBackground: false,
  },
  {
    path: "/trade",
    component: Trade,
    title: "账号交易",
  },
  {
    path: "/trade/detail",
    component: TradeDetail,
    title: "商品详情",
  },
  {
    path: "/trade/notice",
    component: TradeNotice,
    title: "交易须知",
  },

  {
    path: "/trade/search",
    component: TradeSearch,
    title: "搜索",
    theme: "search",
  },

  {
    path: "/article/detail",
    component: ArticleDetail,
    title: "活动详情",
  },
  {
    path: "/comment",
    component: CommentDetail,
    title: "评论详情",
  },
  {
    path: "/comment/submit",
    component: CommentSubmit,
    title: "发布评论",
  },
  {
    path: "/qaquestion",
    component: QAQuestion,
    title: "问答",
  },
  {
    path: "/answer",
    component: QAAnswer,
    title: "问答详情",
  },
  {
    path: "/search",
    component: Search,
    title: "搜索",
    theme: "search",
  },
  {
    path: "/faq",
    component: Faq,
    title: "常见问题",
  },
  {
    path: "/img",
    component: Img,
    invasion: true,
    theme: "bright",
    backColor: "#fff",
  },
  {
    path: "/iframe",
    component: Iframe,
  },
  {
    path: "/video",
    component: Video,
    invasion: true,
  },
  {
    path: "/game/select",
    component: GameSelect,
    title: "选择游戏",
  },
  {
    path: "/feedback",
    component: Feedback,
    title: "投诉反馈",
  },
  {
    path: "/login",
    component: Login,
    invasion: true,
    theme: "dark",
  },
  {
    path: "/phonelogin",
    component: PhoneLogin,
    title: "一键登录",
    invasion: true,
    theme: "dark",
  },
  {
    path: "/register",
    component: Register,
    invasion: true,
    theme: "dark",
  },
  {
    path: "/phone",
    component: Phone,
    title: "绑定手机",
  },
  {
    path: "/phone",
    component: Phone,
    title: "绑定手机",
  },
  {
    path: "/forget",
    component: Forget,
    title: "忘记密码",
  },
  {
    path: "/task/sign",
    component: TaskSign,
    title: "每日签到",
    invasion: true,
    color: "255,152,0",
  },
  {
    path: "/task/novice",
    component: TaskNovice,
    title: "新手任务",
    invasion: true,
    color: "255, 122, 0",
    statusBarBackground: false,
  },
  {
    path: "/task/day",
    component: TaskDay,
    title: "每日任务",
    invasion: true,
    color: "255, 122, 0",
    statusBarBackground: false,
  },
  /*{
    path: '/task/success',
    component: TaskSuccess,
    title: '成就任务',
    invasion: true,
    color: '255,152,0',
  },*/
  {
    path: "/gift",
    component: Gifts,
    title: "礼包中心",
  },
  {
    path: "/gift/search",
    component: GiftSearch,
    title: "礼包搜索",
    className: "nav-view-gift-search",
  },
  {
    path: "/voucher",
    component: Voucher,
    title: "领券中心",
    background: "#f8f8f8",
  },
  {
    path: "/voucher/lateplay",
    component: VoucherLateplay,
    title: "大家都在玩",
    background: "#f8f8f8",
  },
  {
    path: "/server",
    component: Server,
    title: "开服表",
  },
  {
    path: "/credit",
    component: Credit,
    title: "积分商城",
  },
  {
    path: "/credit/gift",
    component: CreditGift,
    title: "礼包&礼品",
  },
  {
    path: "/messages",
    component: Messages,
    title: "消息中心",
  },
  {
    path: "/message",
    component: Message,
    title: "消息详情",
  },
  {
    path: "/user",
    component: UserProfile,
    title: "个人中心",
  },
  {
    path: "/setting",
    component: UserSetting,
    title: "设置",
  },
  {
    path: "/user/nickname",
    component: UserNickname,
    title: "昵称",
  },
  {
    path: "/user/qq",
    component: UserQQ,
    title: "QQ",
  },
  {
    path: "/user/phone",
    component: UserPhone,
    title: "绑定手机号",
  },
  {
    path: "/user/phone-remove",
    component: UserPhoneRemove,
    title: "解绑手机号",
  },
  {
    path: "/user/phone-verify",
    component: UserPhoneVerify,
    title: "验证原手机号",
  },
  {
    path: "/user/phone-replace",
    component: UserPhoneReplace,
    title: "绑定新手机号",
  },
  {
    path: "/user/realname",
    component: UserRealName,
    title: "实名认证",
  },
  {
    path: "/user/password",
    component: UserPassword,
    title: "登录密码",
  },
  {
    path: "/user/password-phone",
    component: UserPasswordPhone,
    title: "登录密码 - 验证手机号",
  },
  {
    path: "/user/password-force",
    component: PasswordForce,
    title: "设置密码",
    back: false,
  },
  {
    path: "/rebate",
    component: Rebate,
    title: "返利中心",
  },
  {
    path: "/rebate/guide",
    component: RebateGuide,
    title: "返利指南",
  },
  {
    path: "/rebate/submit",
    component: RebateSubmit,
    title: "申请详情",
  },
  {
    path: "/rebate/success",
    component: RebateSuccess,
    title: "提交成功",
  },
  {
    path: "/rebate/detail",
    component: RebateDetail,
    title: "申请详情",
    invasion: true,
    color: "255,152,0",
  },
  {
    path: "/user/credit",
    component: UserCredit,
    title: "积分记录",
  },
  {
    path: "/user/voucher",
    component: UserVoucher,
    title: "代金券",
  },
  {
    path: "/user/game",
    component: UserGame,
    title: "我的游戏",
  },

  {
    path: "/user/reserve",
    component: UserReserveGame,
    title: "我的预约",
  },
  {
    path: "/user/likeGame",
    component: UserLikeGame,
    title: "足迹",
  },
  {
    path: "/user/gift",
    component: UserGift,
    title: "我的礼包",
  },
  {
    path: "/invite",
    component: Invite,
    title: "邀请好友",
  },
  {
    path: "/recovery",
    component: Recovery,
    title: "小号回收",
  },
  {
    path: "/recovery/select",
    component: RecoveryDetail,
    title: "选择小号",
  },
  {
    path: "/recovery/record",
    component: RecoveryRecord,
    title: "回收记录",
  },
  {
    path: "/user/bill",
    component: UserBill,
    title: "我的账单",
  },
  {
    path: "/service",
    component: Service,
    title: "联系客服",
  },
  {
    path: "/service/detail",
    component: ServiceDetail,
    title: "联系客服",
  },

  {
    path: "/ptb",
    component: Ptb,
    title: "我的钱包",
  },
  {
    path: "/ptb/record",
    component: PtbRecord,
    title: "充值记录",
  },

  {
    path: "/game/cloud",
    component: GameCloud,
    title: "云玩",
  },

  {
    path: "/feedback/history",
    component: FeedbackHistory,
    title: "投诉反馈历史",
  },
  {
    path: "/feedback/history/detail",
    component: FeedbackHistoryDetail,
    title: "详情",
  },
];
